import { DEFAULT_MARKET } from '@clearscore/config.i18n';

export default {
    [DEFAULT_MARKET]: {
        isEnabled: true,
    },
};
